import axios from 'axios';
export const isDev = () => {
	const {hostname} = window.location;
	if (hostname === 'bhp.lifeon.cl') return false;
	const master = [
		'bhp-inventarios.lifeon.cl'
	];
	return !master.find(m => hostname.includes(m));
}
const dev = isDev();

/* 
const {hostname} = window.location;
const dev = !hostname.includes('bhp-inventarios.lifeon.cl'); */

const PROCEDURE = dev
	? 'https://api.procedimientos.dev.bhp.lifeon.cl'
	: 'https://api.procedimientos.bhp.lifeon.cl';

export const PROCEDURE_FRONT = dev
	? 'https://procedimientos.dev.bhp.lifeon.cl'
	: 'https://procedimientos.bhp.lifeon.cl';

export const ENDPOINT_PROCEDURES = `${PROCEDURE}/procedures/`;
export const ENDPOINT_PROCEDURE = `${PROCEDURE}/procedure/`;
export const ENDPOINT_STANDARD_PROCEDURES = `${PROCEDURE}/standard_procedure/inventory_data/all/`;
export const ENDPOINT_INVENTORY_DATAS = `${PROCEDURE}/inventory_datas/`;
export const ENDPOINT_INVENTORY_DATA = `${PROCEDURE}/inventory_data/`;
export const ENDPOINT_ROLES = `${PROCEDURE}/roles/`;

const headers = {
	'Content-Type': 'application/json',
	Accept: 'application/json',
};

const headersM = {
	'Content-Type': 'application/json',
	Accept: 'application/json',
	'Content-Type': 'multipart/form-data',
};

const FD =  (obj) => {
	const formData = new FormData();
	Object.keys(obj).forEach(k => {
		formData.append(k,obj[k])
	});
	return formData;
};
const setFilters = (filters) => {
	if (!filters) return '';
	const array = Object.keys(filters).map(k => `${k}=${filters[k]}`);
	return `?${array.join('&')}`
};
export const getProcedures = (filters) => axios
	.get(ENDPOINT_PROCEDURES + setFilters(filters), { headers })
	.then(res => res.data);

export const getProcedure = (id) => axios
	.get(ENDPOINT_PROCEDURE + id + '/', { headers  })
	.then(res => res.data);

export const getStandardProcedures = (filters) => axios
	.get(ENDPOINT_STANDARD_PROCEDURES + setFilters(filters), { headers })
	.then(res => res.data);

export const getInventoryDatas = (filters) => axios
	.get(ENDPOINT_INVENTORY_DATAS + setFilters(filters), { headers })
	.then(res => res.data);

export const addInventoryData = (obj) => axios
	.post(ENDPOINT_INVENTORY_DATAS, obj, { headers })
	.then(res => res.data);

export const deleteInventoryData = async (id) => axios
	.delete(`${ENDPOINT_INVENTORY_DATA + id}/`, { headers });

export const editInventoryData = (obj) => axios
	.put(ENDPOINT_INVENTORY_DATA + obj.id + '/', obj, { headers })
	.then(res => res.data);

export const editProcedure = (obj) => axios
	.put(ENDPOINT_PROCEDURE + obj.id + '/', obj, { headers })
	.then(res => res.data);

export const addProcedure = (obj) => axios
	.post(ENDPOINT_PROCEDURES, FD(obj), { headersM })
	.then(res => res.data);

export const addRole = (obj) => axios
	.post(ENDPOINT_ROLES, obj, { headersM })
	.then(res => res.data);

